import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}

import { AssetManagementPlan } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffImprovementActions',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.action_register ?? '',
      "diff-value": _ctx.diffPlan?.action_register,
      label: "8.1 Action Register",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"])
  ]))
}
}

})